import * as React from 'react'
import { normalizeNewCardData } from './normalizeCardData'
import { CampaignCardTemplate, ClientCampaignCard } from '/fiweb/components/CampaignCard'
import { client } from '/~/lib/issuer-client/client'
import { useGetPublishedCampaignCardDataQuery } from '/~/types/issuer-graphql'
import { gtmEventSelectItem } from '/~/utils/googleTagManager'
import { CardTypeEnum } from '/fiweb/components/CampaignCard/types'
import { useServerTimeSync } from '/~/utils/TimeSyncProvider'

interface Props {
  cardData: ClientCampaignCard
  displayForMarketingEmail?: boolean
}

export const NewApiCampaignCard = ({ cardData, displayForMarketingEmail }: Props) => {
  const { serverTimeOffset } = useServerTimeSync()
  const { data } = useGetPublishedCampaignCardDataQuery({
    variables: {
      emissionProcessId: cardData?.id,
      includePublicInvestmentOffer: ![CardTypeEnum.COMING_SOON, CardTypeEnum.DRAFT].includes(cardData.state),
    },
    skip: !client,
    client,
  })

  const publicInvestmentOffer = data?.publishedCampaignCardByEmissionProcessId?.publicInvestmentOffer

  const normalizedData = normalizeNewCardData({
    cardData,
    publicInvestmentOffer,
    visitor: data?.investmentOfferVisitor,
    serverTimeOffset,
  })

  if (!normalizedData) {
    return null
  }

  return (
    <CampaignCardTemplate
      {...normalizedData}
      displayForMarketingEmail={displayForMarketingEmail}
      onClick={() => normalizedData?.clickNavigatesTo && gtmEventSelectItem(normalizedData)}
    />
  )
}
